import { Form, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import * as Yup from "yup";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import { IconButtonSave } from "../../../component/IconSvg";
import LabelRequired from "../../../component/LabelRequired";
import { ObjectSelectAutocomplete } from "../../../phan-he-tiep-nhan-thanh-toan/models/PhanHeTiepNhanModel";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import TextField from "../../../component/TextField";
import { KEY_DS_DANH_MUC_TIEP_DON, TERM_CLASS_IDS } from "../../../utils/Constant";
import { IDanhSachDanhMuc } from "../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { getIndexedDBItem } from "../../../utils/IndexedDB";
import { localStorageItem } from "../../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import InfoPatientRight from "../../components/InfoPatientRight";
import { getCategory } from "../../../utils/AppFunction";

type Props = {
  open: boolean;
  handleCloseModal: () => void;
  handleSubmit: (values: any) => void;
  modalityDetails?: any;
  setModalityDetails?: (values: any) => void;
};
interface IChuyenPhongKham {
  transferReason?: string;
  examinationRequest?: ObjectSelectAutocomplete | null;
  clinic?: ObjectSelectAutocomplete | null;
}
const ChuyenPhongKhamModal = ({ open, handleCloseModal, handleSubmit, modalityDetails, setModalityDetails = () => {}}: Props) => {
  const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
  const intl = useIntl()
  let infoBenhNhan: any = benhNhanInfo;
  const [listYCK, setListYCK] = useState<any>([]);
  const [listPK, setListPK] = useState<any>([]);
  const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);

  const validationSchema = Yup.object({
  });

  const handleGetDsDanhMuc = async () => {
    try {
      const responseDsDanhmuc: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
      const dichVuKhamBenh = await getCategory(TERM_CLASS_IDS.KHAM_BENH);

      setListPK(responseDsDanhmuc?.listPhongKham || []);
      setListYCK(dichVuKhamBenh);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitForm = (values: IChuyenPhongKham) => {
    let submitData = {
      transferReason: values?.transferReason,
      examinationRequest: values?.examinationRequest?.id,
      clinic: values?.clinic?.code,
      transferOrderReq: {
        termId: values?.examinationRequest?.id,
        requestDeptCode: currentUser?.departments?.[0]?.code || "",
        requestDeptName: currentUser?.departments?.[0]?.name || "",
        fulfillDeptId: values?.clinic?.id,
        fulfillDeptCode: values?.clinic?.code,
        fulfillDeptName: values?.clinic?.name,
      }
    };
    handleSubmit({
      ...modalityDetails,
      ...submitData
    });
  };

  useEffect(() => {
    handleGetDsDanhMuc();
    return () => {};
  }, []);
  
  return (
    <Modal centered className="modal fade" role="dialog" show={open} dialogClassName="modal-lg" aria-hidden="true">
      <Formik<IChuyenPhongKham>
        initialValues={{ }}
        validationSchema={validationSchema}
        onSubmit={handleSubmitForm}
      >
        {({ values, setFieldValue, handleChange }) => (
          <Form className="h-100">
            <ModalHeader closeButton onHide={handleCloseModal} className="header-modal">
              <Modal.Title>Chuyển phòng khám</Modal.Title>
            </ModalHeader>

            <ModalBody className="overflow-hidden spaces p-0 ">
              <InfoPatientRight benhNhanInfo={infoBenhNhan} />
              <Row className="spaces pt-10 px-10">
                <em className="text-color-note">Chú ý: </em>
                <Col xs={12} className="d-flex mb-3 flex-column text-color-note">
                  <em>- Sau khi chuyển phòng, hồ sơ bệnh án tại phòng khám này sẽ kết thúc</em>
                  <em>- Toàn bộ quyền kê đơn, xử trí sẽ thuộc về phòng khám tiếp theo</em>
                </Col>
              </Row>

              <Row className="spaces pt-10 px-10">
                <Col xs={12}>
                  <LabelRequired label="Lý do chuyển phòng" />
                  <TextField
                    className="w-100 d-flex flex-column align-items-start flex-auto spaces  pre-line"
                    name="transferReason"
                    labelClassName="ms-0 min-w-145px"
                    as="textarea"
                    value={values?.transferReason || ""}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
              <Row className="spaces pt-10 px-10">
                <LabelRequired label="Yêu cầu khám" />
                <AutocompleteV2
                  options={listYCK}
                  onChange={(option) => {
                    setFieldValue("examinationRequest", option);
                    const phongKhamOption = listPK.find(
                      (item: any) =>
                        item?.code === option?.attributes?.deptClinicCode ||
                        item?.code === option?.attributes?.deptLaboratoryCode
                    );
                    setFieldValue("clinic", phongKhamOption);
                  }}
                  className="spaces "
                  name="examinationRequest"
                  value={values?.examinationRequest}
                />
              </Row>
              <Row className="spaces pt-10 px-10">
                <LabelRequired label="Phòng khám" />
                <AutocompleteV2
                  options={listPK}
                  menuPlacement="top"
                  className="spaces "
                  name="clinicOption"
                  onChange={(option) => setFieldValue("clinic", option)}
                  getOptionLabel={(option) => `${option.code} - ${option.name}`}
                  value={values?.clinic}
                />
              </Row>
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end py-2">
              <Button className="btn-fill" type="submit">
                <IconButtonSave /> Lưu
              </Button>
            </ModalFooter>
          </Form>
          )}
      </Formik>
    </Modal>
  );
};

export default ChuyenPhongKhamModal;
